(function () {
  "use strict";

  angular.module("eltazkaraApp").config(stateConfig);
  stateConfig.$inject = ["$stateProvider"];

  function stateConfig($stateProvider) {
    $stateProvider.state("performance", {
      parent: "app",
      url: "/performance/:id",
      views: {
        "content@": {
          templateUrl: "components/performances/performance.html",
          controller: "PerformanceController",
          controllerAs: "vm",
        },
      },
      resolve: {
        translatePartialLoader: [
          "$translate",
          "$translatePartialLoader",
          function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart("global");
          },
        ],
        auth: function (Principal, $q, $state) {
          return Principal.identity(true).then(function (res) {
            if (!res.IsPhoneVerified || !res.IsEmailVerified) {
              $state.go("account", {});
              return $q.reject("User not verified");
            }

            return true;
          });
        },
      },
    });
  }
})();
